var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColdleadimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 30,
    viewBox: "0 0 80 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3042V29.8264L80 29.908V3.908C71.0971 -2.85 57.3745 3.78857 52.4284 7.54284L52.428 7.5431C47.482 11.2974 39.5684 17.3041 29.6764 12.7991C14.6404 3.78885 3.62712 12.0482 0 17.3042Z",
    fill: "url(#paint0_linear_2513_32125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.555542 17.408C4.18266 12.152 14.6407 3.78812 29.6768 12.7984C39.569 17.3035 47.4827 11.2964 52.4287 7.5421C57.3748 3.78784 70.5415 -2.85009 79.4444 3.9079",
    stroke: "#7183E2",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2513_32125",
    x1: 40.035,
    y1: 0.907715,
    x2: 40.035,
    y2: 36.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D7FA",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdleadimg);
export default __webpack_public_path__ + "static/media/coldleadimg.aec7d9d7ec5e9415b42350a5ef0f61aa.svg";
export { ForwardRef as ReactComponent };